import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faPlay } from "@fortawesome/free-solid-svg-icons";
import AwesomeSlider from "react-awesome-slider";
import withAutoplay from "react-awesome-slider/dist/autoplay";
import "react-awesome-slider/dist/styles.css";
import YouTube, { YouTubeProps } from "react-youtube";
import {
  ReactCompareSlider,
  ReactCompareSliderImage,
} from "react-compare-slider";

function Home() {
  const [myData, setMyData] = useState([]);
  const [isError, setIsError] = useState("");

  const imageUrls = [
    "images/main-slider/slider-1/cow1.png",
    "images/main-slider/slider-1/cow2.png",
  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % imageUrls.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const isMobile = window.innerWidth <= 575;

  const getMyProductData = async () => {
    try {
      const response = await fetch("/db.json"); // Assuming db.json is in the public folder
      if (response.ok) {
        const data = await response.json();
        console.log(data, "data");
        setMyData(data.homeposts);
      } else {
        throw new Error("Error loading JSON data");
      }
    } catch (error) {
      setIsError(error.message);
    }
  };

  const navigate = useNavigate();

  const productNavigate = (id) => {
    navigate("/product/" + id);
  };

  const Navigate = () => {
    navigate("/product");
  };

  const aboutNavigation = () => {
    navigate("/about");
  };

  useEffect(() => {
    getMyProductData();
  }, []);

  const [currentImage, setCurrentImage] = useState(0);
  const images = [
    "images/b1.png",
    "images/b2.png",
    "images/b3.png",
    "images/b4.png",
    "images/b3.png",
    "images/b2.png",
    "images/b1.png",
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImage((prevImage) => (prevImage + 1) % images.length);
    }, 3000);

    return () => clearInterval(timer); // Cleanup the timer on component unmount
  }, []);

  const [slideDirection, setSlideDirection] = useState("slide-in");

  // useEffect(() => {
  //   console.log("change", currentImage);
  //   const timeout = setTimeout(() => {
  //     setSlideDirection("slide-out");
  //     setSlideDirection("slide-in");
  //   }, 5000);

  //   return () => clearTimeout(timeout); // Cleanup the timeout on image change
  // }, [currentImage]);

  const slideStyle = {
    // position: "absolute",
    // top: 0,
    // left: slideDirection === "slide-in" ? "0" : "-100%",
    opacity: 1,
    transition: "opacity 0.5s, transform 0.5s",
    transform: "translateX(0)",
    width: "500px",
    height: "382px",
    textAlign: "right",
    lineHeight: "0px",
    borderWidth: "0px",
    margin: "0px",
    padding: "0px",
    letterSpacing: "0px",
    fontWeight: 400,
    fontSize: "14px",
    cursor: "url('https://3waytech.co/wp-content/daan.cur'), auto",
  };

  return (
    <>
      <div className="page-content" style={{ marginBottom: "-100px" }}>
        {/* SLIDER START */}
        <div className="slider-outer">
          <div
            className="forcefullwidth_wrapper_tp_banner"
            id="aon-slide-one_forcefullwidth"
            style={{
              position: "relative",
              width: "100%",
              height: "auto",
              marginTop: "0px",
              marginBottom: "0px",
            }}
          >
            <div
              id="welcome_wrapper"
              className="rev_slider_wrapper fullscreen-container tp-mouseover"
              data-alias="goodnews-header"
              data-source="gallery"
              style={{
                marginTop: "0px",
                marginBottom: "0px",
                position: "absolute",
                overflow: "visible",
                height: "822px",
                width: "100%",
                left: "0px",
              }}
            >
              <div
                id="aon-slide-one"
                className="rev_slider fullscreenbanner revslider-initialised tp-simpleresponsive rev_redraw_on_blurfocus"
                style={{
                  maxHeight: "822px",
                  marginTop: "0px",
                  marginBottom: "0px",
                  height: "822px",
                }}
                data-version="5.4.3.1"
                data-slideactive="rs-901"
              >
                <ul
                  className="tp-revslider-mainul"
                  style={{
                    visibility: "visible",
                    display: "block",
                    overflow: "hidden",
                    width: "100%",
                    height: "100%",
                    maxHeight: "none",
                  }}
                >
                  {/* SLIDE 1 */}
                  <li
                    data-index="rs-901"
                    data-transition="fade"
                    data-slotamount="default"
                    data-hideafterloop={0}
                    data-hideslideonmobile="off"
                    data-easein="default"
                    data-easeout="default"
                    data-masterspeed="default"
                    data-thumb="images/main-slider/slider-1/image-1.jpg"
                    data-rotate={0}
                    data-fstransition="fade"
                    data-fsmasterspeed={300}
                    data-fsslotamount={7}
                    data-saveperformance="off"
                    data-title="Slide Title"
                    data-param1={1}
                    data-param2
                    data-param3
                    data-param4
                    data-param5
                    data-param6
                    data-param7
                    data-param8
                    data-param9
                    data-param10
                    data-description
                    className="tp-revslider-slidesli active-revslide"
                    style={{
                      perspective: "6000px",
                      width: "100%",
                      height: "100%",
                      overflow: "hidden",
                      zIndex: 20,
                      visibility: "inherit",
                      opacity: 1,
                      backgroundColor: "rgba(255, 255, 255, 0)",
                    }}
                  >
                    {/* MAIN IMAGE */}
                    <div
                      className="slotholder"
                      style={{
                        position: "absolute",
                        top: "0px",
                        left: "0px",
                        zIndex: 0,
                        width: "100%",
                        height: "100%",
                        visibility: "inherit",
                        opacity: 1,
                        transform: "matrix(1, 0, 0, 1, 0, 0)",
                      }}
                    >
                      {/*Runtime Modification - Img tag is Still Available for SEO Goals in Source - <img src="images/main-slider/slider-1/image-1.jpg" alt="" data-lazyload="images/main-slider/slider-1/image-1.jpg" data-bgposition="center center" data-kenburns="on" data-duration="10000" data-ease="Power1.easeOut" data-scalestart="110" data-scaleend="100" data-rotatestart="0" data-rotateend="0" data-offsetstart="0 0" data-offsetend="0 0" class="rev-slidebg xyz defaultimg" data-no-retina="">*/}
                      <div
                        className="tp-bgimg defaultimg "
                        data-bgcolor="undefined"
                        style={{
                          backgroundRepeat: "no-repeat",
                          backgroundImage:
                            'url("images/main-slider/slider-1/image-1.jpg")',
                          backgroundSize: "cover",
                          backgroundPosition: "center center",
                          width: "100%",
                          height: "100%",
                          opacity: 1,
                          visibility: "inherit",
                          zIndex: 20,
                        }}
                        src="images/main-slider/slider-1/image-1.jpg"
                      />
                      <div
                        className="tp-kbimg-wrap "
                        style={{
                          zIndex: 2,
                          width: "100%",
                          height: "100%",
                          top: "0px",
                          left: "0px",
                          position: "absolute",
                          transform: "translate3d(0px, -18.6094px, 0px)",
                          transformOrigin: "0% 0% 0px",
                        }}
                      >
                        <img
                          className="tp-kbimg"
                          src="images/main-slider/slider-1/image-1.jpg"
                          style={{
                            position: "absolute",
                            width: "1833px",
                            transform: "translate3d(0px, 0px, 0px)",
                            height: "859px",
                            transformOrigin: "0% 0% 0px",
                          }}
                          width="undefined"
                          height="undefined"
                        />
                      </div>
                    </div>
                    {/* LAYER NR. 1 [ for overlay ] */}
                    <div
                      className="tp-parallax-wrap"
                      style={{
                        position: "absolute",
                        display: "block",
                        visibility: "visible",
                        left: "0px",
                        top: "0px",
                        zIndex: 1,
                      }}
                    >
                      <div
                        className="tp-loop-wrap"
                        style={{ position: "absolute", display: "block" }}
                      >
                        <div
                          className="tp-mask-wrap"
                          style={{
                            position: "absolute",
                            display: "block",
                            overflow: "visible",
                          }}
                        >
                          <div
                            className="tp-caption tp-shape tp-shapewrapper "
                            id="slide-901-layer-1"
                            data-x="['center','center','center','center']"
                            data-hoffset="['0','0','0','0']"
                            data-y="['middle','middle','middle','middle']"
                            data-voffset="['0','0','0','0']"
                            data-width="full"
                            data-height="full"
                            data-whitespace="nowrap"
                            data-type="shape"
                            data-basealign="slide"
                            data-responsive_offset="off"
                            data-responsive="off"
                            data-frames='[
                                {"from":"opacity:0;","speed":1000,"to":"o:1;","delay":0,"ease":"Power4.easeOut"},
                                {"delay":"wait","speed":1000,"to":"opacity:0;","ease":"Power4.easeOut"}
                                ]'
                            data-textalign="['left','left','left','left']"
                            data-paddingtop="[0,0,0,0]"
                            data-paddingright="[0,0,0,0]"
                            data-paddingbottom="[0,0,0,0]"
                            data-paddingleft="[0,0,0,0]"
                            style={{
                              zIndex: 1,
                              backgroundColor: "rgba(255, 255, 255, 0)",
                              borderColor: "rgba(0, 0, 0, 0)",
                              borderWidth: "0px",
                              visibility: "inherit",
                              transition: "none 0s ease 0s",
                              textAlign: "left",
                              lineHeight: "25px",
                              margin: "0px",
                              padding: "0px",
                              letterSpacing: "0px",
                              fontWeight: 400,
                              fontSize: "14px",
                              whiteSpace: "nowrap",
                              minHeight: "822px",
                              minWidth: "1833px",
                              opacity: 1,
                              transformOrigin: "50% 50% 0px",
                              transform:
                                "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)",
                            }}
                          ></div>
                        </div>
                      </div>
                    </div>
                    {/* LAYER NR. 2 [ for title ] */}
                    <div
                      className="tp-parallax-wrap"
                      style={{
                        position: "absolute",
                        display: "block",
                        visibility: "visible",
                        left: isMobile ? "0px" : "347px",
                        top: isMobile ? "111px" : "224px",
                        zIndex: 11,
                      }}
                    >
                      <div
                        className="tp-loop-wrap"
                        style={{ position: "absolute", display: "block" }}
                      >
                        <div
                          className="tp-mask-wrap"
                          style={{
                            position: "absolute",
                            display: "block",
                            overflow: "visible",
                          }}
                        >
                          <div
                            className="tp-caption   tp-resizeme"
                            id="slide-901-layer-2"
                            data-x="['left','left','center','center']"
                            data-hoffset="[50','50','0','0']"
                            data-y="['middle','middle','middle','middle']"
                            data-voffset="['-100','-100','-200','-200']"
                            data-fontsize="['84','52','42','38']"
                            data-lineheight="['84','52','42','38']"
                            data-width="['800','600','600','480']"
                            data-height="['none','none','none','none']"
                            data-whitespace="['normal','normal','normal','normal']"
                            data-type="text"
                            data-responsive_offset="on"
                            data-frames='[
                            {"from":"y:100px(R);opacity:0;","speed":1000,"to":"o:1;","delay":2000,"ease":"Power4.easeOut"},
                            {"delay":"wait","speed":1000,"to":"y:-50px;opacity:0;","ease":"Power2.easeInOut"}
                            ]'
                            data-textalign="['left','left','center','center']"
                            data-paddingtop="[5,5,5,5]"
                            data-paddingright="[0,0,0,20]"
                            data-paddingbottom="[0,0,0,0]"
                            data-paddingleft="[0,0,0,20]"
                            style={{
                              zIndex: 11,
                              whiteSpace: "normal",
                              fontWeight: 900,
                              borderWidth: "0px",
                              fontFamily: "Cormorant",
                              visibility: "inherit",
                              transition: "none 0s ease 0s",
                              textAlign: isMobile ? "center" : "left",
                              lineHeight: isMobile ? "30px" : "84px",
                              margin: "0px",
                              padding: isMobile
                                ? "4px 16px 0px"
                                : "5px 0px 0px",
                              letterSpacing: "0px",
                              fontSize: isMobile ? "30px" : "84px",
                              minHeight: "0px",
                              minWidth: isMobile ? "375px" : "800px",
                              maxHeight: "none",
                              maxWidth: isMobile ? "375px" : "800px",
                              transformOrigin: "50% 50% 0px",
                              transform:
                                "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)",
                            }}
                          >
                            <span
                              className="site-text-white"
                              style={{
                                transition: "none 0s ease 0s",
                                textAlign: isMobile ? "center" : "left",
                                lineHeight: isMobile ? "30px" : "84px",
                                borderWidth: "0px",
                                margin: "0px",
                                padding: "0px",
                                letterSpacing: "0px",
                                fontWeight: 900,
                                fontSize: isMobile ? "30px" : "84px",
                              }}
                            >
                              We Provide You With All Cattle Feeds
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* LAYER NR. 3 [ for paragraph] */}
                    <div
                      className="tp-parallax-wrap"
                      style={{
                        position: "absolute",
                        display: "block",
                        visibility: "visible",
                        left: isMobile ? "0px" : "347px",
                        top: isMobile ? "196px" : "433px",
                        zIndex: 11,
                      }}
                    >
                      <div
                        className="tp-loop-wrap"
                        style={{ position: "absolute", display: "block" }}
                      >
                        <div
                          className="tp-mask-wrap"
                          style={{
                            position: "absolute",
                            display: "block",
                            overflow: "visible",
                          }}
                        >
                          <div
                            className="tp-caption  tp-resizeme"
                            id="slide-901-layer-3"
                            data-x="['left','left','center','center']"
                            data-hoffset="['50','50','0','0']"
                            data-y="['middle','middle','middle','middle']"
                            data-voffset="['50','20','-70','-100']"
                            data-fontsize="['19','19','18','16']"
                            data-lineheight="['28','28','28','22']"
                            data-width="['800','600','600','480']"
                            data-height="['none','none','none','none']"
                            data-whitespace="['normal','normal','normal','normal']"
                            data-type="text"
                            data-responsive_offset="on"
                            data-frames='[
                            {"from":"y:100px(R);opacity:0;","speed":1500,"to":"o:1;","delay":2500,"ease":"Power4.easeOut"},
                            {"delay":"wait","speed":1000,"to":"y:-50px;opacity:0;","ease":"Power2.easeInOut"}
                            ]'
                            data-textalign="['left','left','center','center']"
                            data-paddingtop="[0,0,0,0]"
                            data-paddingright="[0,0,0,30]"
                            data-paddingbottom="[0,0,0,0]"
                            data-paddingleft="[0,0,0,30]"
                            style={{
                              zIndex: isMobile ? 11 : 1,
                              fontWeight: 400,
                              color: "rgb(255, 255, 255)",
                              borderWidth: "0px",
                              fontFamily: "Heebo, sans-serif",
                              visibility: "inherit",
                              transition: "none 0s ease 0s",
                              textAlign: isMobile ? "center" : "left",
                              lineHeight: isMobile ? "17px" : "28px",
                              margin: "0px",
                              padding: isMobile ? "0px 23px" : "0px",
                              letterSpacing: "0px",
                              fontSize: isMobile ? "13px" : "19px",
                              whiteSpace: "normal",
                              minHeight: "0px",
                              minWidth: isMobile ? "375px" : "800px",
                              maxHeight: "none",
                              maxWidth: isMobile ? "375px" : "800px",
                              opacity: 1,
                              transformOrigin: "50% 50% 0px",
                              transform:
                                "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)",
                            }}
                          >
                            Offering nutritious range of Cattle Feed Supplements
                            including Cattle Feed Mix Pashu Aahaar, Coconut
                            Cattle Feed, Cattle Feed Mix, etc.
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* LAYER NR. 4 [ for see all service botton ] */}
                    <div
                      className="tp-parallax-wrap"
                      style={{
                        position: "absolute",
                        display: "block",
                        visibility: "visible",
                        left: isMobile ? "70px" : "347px",
                        top: isMobile ? "266px" : "522px",
                        zIndex: 13,
                      }}
                    >
                      <div
                        className="tp-loop-wrap"
                        style={{ position: "absolute", display: "block" }}
                      >
                        <div
                          className="tp-mask-wrap"
                          style={{
                            position: "absolute",
                            display: "block",
                            overflow: "visible",
                          }}
                        >
                          <div
                            className="tp-caption tp-resizeme"
                            id="slide-901-layer-4"
                            data-x="['left','left','center','center']"
                            data-hoffset="['50','50','0','0']"
                            data-y="['middle','middle','middle','middle']"
                            data-voffset="['150','150','60','0']"
                            data-lineheight="['none','none','none','none']"
                            data-width="['300','300','300','300']"
                            data-height="['none','none','none','none']"
                            data-whitespace="['normal','normal','normal','normal']"
                            data-type="text"
                            data-responsive_offset="on"
                            data-frames='[ 
                                {"from":"y:100px(R);opacity:0;","speed":2000,"to":"o:1;","delay":2500,"ease":"Power4.easeOut"},
                                {"delay":"wait","speed":1000,"to":"y:-50px;opacity:0;","ease":"Power2.easeInOut"}
                                ]'
                            data-textalign="['left','left','center','center']"
                            data-paddingtop="[0,0,0,0]"
                            data-paddingright="[0,0,0,0]"
                            data-paddingbottom="[0,0,0,0]"
                            data-paddingleft="[0,0,0,0]"
                            style={{
                              zIndex: 13,
                              textTransform: "uppercase",
                              visibility: "inherit",
                              transition: "none 0s ease 0s",
                              textAlign: isMobile ? "center" : "left",
                              borderWidth: "0px",
                              margin: "0px",
                              padding: "0px",
                              letterSpacing: "0px",
                              fontWeight: 400,
                              fontSize: isMobile ? "11px" : "14px",
                              whiteSpace: "normal",
                              minHeight: "0px",
                              minWidth: isMobile ? "234px" : "300px",
                              maxHeight: "none",
                              maxWidth: isMobile ? "234px" : "300px",
                              opacity: 1,
                              transform:
                                "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)",
                              transformOrigin: "50% 50% 0px",
                            }}
                          >
                            <a
                              className="site-button btn-animate-one"
                              style={{
                                transition: "none 0s ease 0s",
                                textAlign: "inherit",
                                lineHeight: isMobile ? "22px" : "28px",
                                borderWidth: "0px",
                                margin: "0px",
                                padding: isMobile ? "16px 23px" : "20px 30px",
                                letterSpacing: isMobile ? "0px" : "1px",
                                fontWeight: 700,
                                fontSize: isMobile ? "13px" : "16px",
                              }}
                              onClick={() => {
                                window.open("/cattle feed.pdf");
                              }}
                            >
                              Download Brochure{" "}
                              <i
                                className="btn-arrow-icon fa fa-download"
                                // style={{
                                //   transition: "none 0s ease 0s",
                                //   textAlign: "inherit",
                                //   lineHeight: "28px",
                                //   borderWidth: "1px",
                                //   margin: "0px 0px 0px 5px",
                                //   padding: "0px",
                                //   letterSpacing: "1px",
                                //   fontWeight: 400,
                                //   fontSize: "16px",
                                // }}
                              />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="tp-caption tp-resizeme"
                      id="slide-901-layer-6"
                      data-x="['right','right','center','center']"
                      data-hoffset="['-150','0','0','0']"
                      data-y="['bottom','bottom','bottom','bottom']"
                      data-voffset="['120','120','50','50']"
                      data-width="none"
                      data-height="none"
                      data-whitespace="nowrap"
                      data-type="image"
                      data-responsive_offset="off"
                      data-frames='[{"from":"x:right;","speed":1200,"to":"o:1;","delay":2500,"ease":"Power3.easeOut"},{"delay":"wait","speed":1500,"to":"opacity:0;","ease":"Power4.easeIn"}]'
                      data-textalign="['right','right','center','center']"
                      data-paddingtop="[0,0,0,0]"
                      data-paddingright="[0,0,0,0]"
                      data-paddingbottom="[0,0,0,0]"
                      data-paddingleft="[0,0,0,0]"
                      style={{
                        position: "absolute",
                        display: "block",
                        visibility: "visible",
                        left: isMobile ? "0px" : "1100px",
                        top: isMobile ? "373px" : "122px",
                        zIndex: 13,
                      }}
                    >
                      <div className="animate-v">
                        <img
                          src={images[currentImage]}
                          alt=""
                          data-ww="['491px','380px','150px','150px']"
                          data-hh="['580px','449px','175px','175px']"
                          width={437}
                          height={591}
                          data-no-retina
                        />
                      </div>
                    </div>
                    {/* LAYER NR. 7  Img Cow */}
                    <div
                      className="tp-parallax-wrap"
                      style={{
                        position: "absolute",
                        display: "block",
                        visibility: "visible",
                        left: "268px",
                        top: "-103px",
                        zIndex: 1,
                      }}
                    >
                      <div
                        className="tp-loop-wrap"
                        style={{ position: "absolute", display: "block" }}
                      >
                        <div
                          className="tp-mask-wrap"
                          style={{
                            position: "absolute",
                            display: "block",
                            overflow: "visible",
                          }}
                        >
                          <div
                            className="tp-caption   tp-resizeme "
                            id="slide-901-layer-7"
                            data-x="['left','left','center','center']"
                            data-hoffset="['-250','0','0','0']"
                            data-y="['bottom','bottom','bottom','bottom']"
                            data-voffset="['0','0','0','0']"
                            data-width="none"
                            data-height="none"
                            data-whitespace="nowrap"
                            data-basealign="slide"
                            data-type="image"
                            data-responsive_offset="off"
                            data-frames='[{"from":"x:left;","speed":1500,"to":"o:1;","delay":2500,"ease":"Power3.easeOut"},{"delay":"wait","speed":1500,"to":"opacity:0;","ease":"Power4.easeIn"}]'
                            data-textalign="['right','right','center','center']"
                            data-paddingtop="[0,0,0,0]"
                            data-paddingright="[0,0,0,0]"
                            data-paddingbottom="[0,0,0,0]"
                            data-paddingleft="[0,0,0,0]"
                            style={{
                              zIndex: 1,
                              borderWidth: "0px",
                              visibility: "inherit",
                              transition: "none 0s ease 0s",
                              textAlign: "right",
                              lineHeight: "0px",
                              margin: "0px",
                              padding: "0px",
                              letterSpacing: "0px",
                              fontWeight: 400,
                              fontSize: "14px",
                              whiteSpace: "nowrap",
                              minHeight: "0px",
                              minWidth: "0px",
                              maxHeight: "none",
                              maxWidth: "none",
                              opacity: 1,
                              transformOrigin: "50% 50% 0px",
                              transform:
                                "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)",
                            }}
                          >
                            {/* {images.map((image, index) => {
     const isCurrentImage = index === currentImage;
        
        return ( */}
                            <div
                              className="tp-parallax-wrap"
                              style={{
                                position: "absolute",
                                display: "block",
                                visibility: "visible",
                                left: "0px",
                                top: "-103px",
                                zIndex: 1,
                              }}
                            >
                              <div
                                className="tp-loop-wrap"
                                style={{
                                  position: "absolute",
                                  display: "block",
                                }}
                              >
                                <div
                                  className="tp-mask-wrap"
                                  style={{
                                    position: "absolute",
                                    display: "block",
                                    overflow: "visible",
                                  }}
                                >
                                  <div
                                    className="tp-caption tp-resizeme"
                                    id="slide-901-layer-7"
                                    data-x="['left','left','center','center']"
                                    data-hoffset="['-250','0','0','0']"
                                    data-y="['bottom','bottom','bottom','bottom']"
                                    data-voffset="['0','0','0','0']"
                                    data-width="none"
                                    data-height="none"
                                    data-whitespace="nowrap"
                                    data-basealign="slide"
                                    data-type="image"
                                    data-responsive_offset="off"
                                    data-frames='[{"from":"x:left;","speed":1500,"to":"o:1;","delay":2500,"ease":"Power3.easeOut"},{"delay":"wait","speed":1500,"to":"opacity:0;","ease":"Power4.easeIn"}]'
                                    data-textalign="['right','right','center','center']"
                                    data-paddingtop="[0,0,0,0]"
                                    data-paddingright="[0,0,0,0]"
                                    data-paddingbottom="[0,0,0,0]"
                                    data-paddingleft="[0,0,0,0]"
                                    style={{
                                      zIndex: 1,
                                      borderWidth: "0px",
                                      visibility: "inherit",
                                      transition: "none 0s ease 0s",
                                      textAlign: "right",
                                      lineHeight: "0px",
                                      margin: "0px",
                                      padding: "0px",
                                      letterSpacing: "0px",
                                      fontWeight: 400,
                                      fontSize: "14px",
                                      whiteSpace: "nowrap",
                                      minHeight: "0px",
                                      minWidth: "0px",
                                      maxHeight: "none",
                                      maxWidth: "none",
                                      opacity: 1,
                                      transformOrigin: "50% 50% 0px",
                                      transform:
                                        "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)",
                                    }}
                                  >
                                    <div
                                      className="aon-banner-top-left-pic"
                                      style={{
                                        transition: "none 0s ease 0s",
                                        textAlign: "right",
                                        lineHeight: "0px",
                                        borderWidth: "0px",
                                        margin: "0px",
                                        padding: "0px",
                                        letterSpacing: "0px",
                                        fontWeight: 400,
                                        fontSize: "14px",
                                        left:
                                          currentImageIndex === 0
                                            ? "-452px"
                                            : "-269px",
                                      }}
                                    >
                                      <img
                                        src={imageUrls[currentImageIndex]}
                                        alt=""
                                        style={{
                                          width: "500px",
                                          // height: "382px",
                                          transition: "none 0s ease 0s",
                                          textAlign: "right",
                                          lineHeight: "0px",
                                          borderWidth: "0px",
                                          margin: "0px",
                                          padding: "0px",
                                          letterSpacing: "0px",
                                          fontWeight: 400,
                                          fontSize: "14px",
                                        }}
                                      />
                                      <div
                                        className="aon-banner-top-left-circle animte-plus"
                                        style={{
                                          transition: "none 0s ease 0s",
                                          textAlign: "right",
                                          lineHeight: "0px",
                                          borderWidth: "0px",
                                          margin: "0px",
                                          padding: "0px",
                                          letterSpacing: "0px",
                                          fontWeight: 400,
                                          fontSize: "14px",
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* );
      })} */}
                            {/* {images.map((image, index) => (
                                  <div
                                  className="aon-banner-top-left-pic"
                                  style={{
                                    transition: "none 0s ease 0s",
                                    textAlign: "right",
                                    lineHeight: "0px",
                                    borderWidth: "0px",
                                    margin: "0px",
                                    padding: "0px",
                                    letterSpacing: "0px",
                                    fontWeight: 400,
                                    fontSize: "14px",
                                    left: "-452px",
                                  }}
                                >
                                <img
                                  key={index}
                                  src={image}
                                  alt={`Image ${index + 1}`}
                                  style={index === currentImage ? slideStyle : prevSlideStyle}
                                />
                                <div
                                className="aon-banner-top-left-circle animte-plus"
                                style={{
                                  transition: "none 0s ease 0s",
                                  textAlign: "right",
                                  lineHeight: "0px",
                                  borderWidth: "0px",
                                  margin: "0px",
                                  padding: "0px",
                                  letterSpacing: "0px",
                                  fontWeight: 400,
                                  fontSize: "14px",
                                }}
                              />
                            </div>
                          // </div>
      ))} */}
                            {/* <img
                                src={images[currentImage]}
                                alt=""
                                style={{
                                  width: "500px",
                                  height: "382px",
                                  transition: "none 0s ease 0s",
                                  textAlign: "right",
                                  lineHeight: "0px",
                                  borderWidth: "0px",
                                  margin: "0px",
                                  padding: "0px",
                                  letterSpacing: "0px",
                                  fontWeight: 400,
                                  fontSize: "14px",
                                  transition: 'none 0s ease 0s',
                                  transform: 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)'
                                }}
                              /> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
                <div
                  className="tp-bannertimer tp-bottom"
                  style={{
                    visibility: "hidden",
                    width: "95.26%",
                    transform: "translate3d(0px, 0px, 0px)",
                  }}
                />
                <div className="tp-loader spinner3" style={{ display: "none" }}>
                  <div className="dot1" />
                  <div className="dot2" />
                  <div className="bounce1" />
                  <div className="bounce2" />
                  <div className="bounce3" />
                </div>
                <div
                  className="tp-leftarrow tparrows zeus"
                  style={{
                    top: "100%",
                    transform: "matrix(1, 0, 0, 1, 20, -180)",
                    left: "0px",
                    visibility: "hidden",
                    opacity: 0,
                  }}
                >
                  <div className="tp-title-wrap">
                    {" "}
                    <div
                      className="tp-arr-imgholder"
                      style={{
                        backgroundImage:
                          'url("images/main-slider/slider-2/image-2.jpg")',
                      }}
                    />{" "}
                    <div className="tp-arr-img-over" />{" "}
                    <span className="tp-arr-titleholder">Slide Title</span>{" "}
                  </div>
                </div>
                <div
                  className="tp-rightarrow tparrows zeus"
                  style={{
                    top: "100%",
                    transform: "matrix(1, 0, 0, 1, 20, -90)",
                    left: "0px",
                    visibility: "hidden",
                    opacity: 0,
                  }}
                >
                  <div className="tp-title-wrap">
                    {" "}
                    <div
                      className="tp-arr-imgholder"
                      style={{
                        backgroundImage:
                          'url("images/main-slider/slider-2/image-2.jpg")',
                      }}
                    />{" "}
                    <div className="tp-arr-img-over" />{" "}
                    <span className="tp-arr-titleholder">Slide Title</span>{" "}
                  </div>
                </div>
                <div
                  className="tp-bullets bullet-bar horizontal nav-pos-hor-center nav-pos-ver-bottom nav-dir-horizontal tp-forcenotvisible"
                  style={{
                    width: "35px",
                    height: "15px",
                    top: "100%",
                    transform: "matrix(1, 0, 0, 1, -17, -45)",
                    left: "50%",
                  }}
                >
                  <div
                    className="tp-bullet selected"
                    style={{ left: "0px", top: "0px" }}
                  />
                  <div
                    className="tp-bullet"
                    style={{ left: "20px", top: "0px" }}
                  />
                </div>
              </div>
            </div>
            <div
              className="tp-fullwidth-forcer"
              style={{ width: "100%", height: "822px" }}
            />
          </div>
        </div>

        {/* SLIDER END */}
        {/* About Section */}
        <section className="aon-about-area">
          <div className="site-top-line" />
          {/* <div className="container">
            <div
              className="row align-items-center justify-content-center mb-5  wow fadeInDown"
              data-wow-duration="1500ms"
            >

              <div className="mb-4 col-lg-2 col-md-3 col-sm-4 col-6 text-center">
                <div className="site-clent-logo">
                  <img src="images/clients/logo1.png" alt="" />
                </div>
              </div>
              <div className="mb-4 col-lg-2 col-md-3 col-sm-4 col-6 text-center">
                <div className="site-clent-logo">
                  <img src="images/clients/logo2.png" alt="" />
                </div>
              </div>
              <div className="mb-4 col-lg-2 col-md-3 col-sm-4 col-6 text-center">
                <div className="site-clent-logo">
                  <img src="images/clients/logo3.png" alt="" />
                </div>
              </div>
              <div className="mb-4 col-lg-2 col-md-3 col-sm-4 col-6 text-center">
                <div className="site-clent-logo">
                  <img src="images/clients/logo4.png" alt="" />
                </div>
              </div>
              <div className="mb-4 col-lg-2 col-md-3 col-sm-4 col-6 text-center">
                <div className="site-clent-logo">
                  <img src="images/clients/logo5.png" alt="" />
                </div>
              </div>
              <div className="mb-4 col-lg-2 col-md-3 col-sm-4 col-6 text-center">
                <div className="site-clent-logo">
                  <img src="images/clients/logo6.png" alt="" />
                </div>
              </div>
            </div>
          </div> */}
          <div className="container">
            {/*Title Section Start*/}

            <div className="section-head center">
              <span className="aon-sub-icon">
                <img src="images/icon.png" alt="" />
              </span>
              <h2 className="aon-title aon-title-line">
                Welcome to <span>Mahalaxmi</span> Oil Mill
              </h2>
              <p>
                We are a leading manufacturer and supplier of high-quality
                Cattle Feed Supplements, catering to the growing demand for
                nutritious animal nutrition. With our vast experience in the
                industry since 2006, we have established ourselves as a trusted
                name in providing superior feeds to enhance the health and
                well-being of cattle.and Cattle Feed Mix. These feeds are
                formulated using the finest raw materials, ensuring their
                highest quality and nutritional value.
              </p>
            </div>
            {/*Title Section End*/}
            <div className="section-content">
              <div className="about-year-top d-flex justify-content-center align-items-center">
                <div className="about-year-since">Our Products</div>
                {/* <div className="about-year-pic">
                  <img src="images/about.png" alt="" />
                </div>
                <div className="about-year-sign">
                  <img src="images/sign2.png" alt="" />
                </div> */}
              </div>
              {/* <div
                className="section-head center"
                style={{ marginTop: "5rem" }}
              >
                <span className="aon-sub-title">Our All Product</span>
                <h2 className="aon-title">Views All Product</h2>
              </div> */}
              <div className="aon-med-team-section">
                <div className="row">
                  {/* Column 1 */}
                  {myData.map((data, index) => {
                    return (
                      <span
                        className="col-lg-3 col-md-6 wow fadeInDown"
                        data-wow-duration="1000ms"
                        onClick={() => productNavigate(data.id)}
                      >
                        <div className="aon-about-box aon-icon-effect">
                          <div className="aon-about-icon">
                            <img
                              src={data.image}
                              alt=""
                              style={{ height: "270px" }}
                            />
                          </div>
                          <div className="aon-about-circle" />
                          <h4 className="aon-about-title">{data.title}</h4>
                          {/* <p className="aon-about-text">
                            Mauris iaculis urna eget est euismod, in auctor dui
                            porta. Mauris non porta lacus.
                          </p> */}
                          {/* <a className="aon-about-btn" href="javascript:;">
                            <FontAwesomeIcon icon={faAngleRight} />
                          </a> */}
                        </div>
                      </span>
                    );
                  })}
                  {/* <div
                    className="col-lg-3 col-md-6 wow fadeInDown"
                    data-wow-duration="2000ms"
                  >
                    <div className="aon-about-box aon-icon-effect">
                      <div className="aon-about-icon">
                        <i className="flaticon-fruit aon-icon" />
                      </div>
                      <div className="aon-about-circle" />
                      <h4 className="aon-about-title">
                        Milk Online Sales System.
                      </h4>
                      <p className="aon-about-text">
                        Mauris iaculis urna eget est euismod, in auctor dui
                        porta. Mauris non porta lacus.
                      </p>
                      <a className="aon-about-btn" href="javascript:;">
                        <i className="fa fa-angle-right" />
                      </a>
                    </div>
                  </div>
                  <div
                    className="col-lg-3 col-md-6 wow fadeInDown"
                    data-wow-duration="3000ms"
                  >
                    <div className="aon-about-box aon-icon-effect">
                      <div className="aon-about-icon">
                        <i className="flaticon-paint-palette aon-icon" />
                      </div>
                      <div className="aon-about-circle" />
                      <h4 className="aon-about-title">
                        Milk Online Sales System.
                      </h4>
                      <p className="aon-about-text">
                        Mauris iaculis urna eget est euismod, in auctor dui
                        porta. Mauris non porta lacus.
                      </p>
                      <a className="aon-about-btn" href="javascript:;">
                        <i className="fa fa-angle-right" />
                      </a>
                    </div>
                  </div>
                 
                  <div
                    className="col-lg-3 col-md-6 wow fadeInDown"
                    data-wow-duration="4000ms"
                  >
                    <div className="aon-about-box aon-icon-effect">
                      <div className="aon-about-icon">
                        <i className="flaticon-dairy-products aon-icon" />
                      </div>
                      <div className="aon-about-circle" />
                      <h4 className="aon-about-title">
                        Milk Online Sales System.
                      </h4>
                      <p className="aon-about-text">
                        Mauris iaculis urna eget est euismod, in auctor dui
                        porta. Mauris non porta lacus.
                      </p>
                      <a className="aon-about-btn" href="javascript:;">
                        <i className="fa fa-angle-right" />
                      </a>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
            {/*Welcome Pic Circle*/}
            <div className="aon-welcome-pic animate-v">
              <img src="images/circle-pic.png" alt="" />
            </div>

            <div className="view-more-btn text-center">
              <button
                className="site-button btn-animate-one"
                onClick={Navigate}
              >
                View All Products
                <i className="btn-arrow-icon fa fa-angle-right" />
              </button>
            </div>
          </div>
          <div className="site-bot-line" />
        </section>
        {/* About Section End */}
        {/* Team Section */}
        <section
          className="aon-team-area"
          style={{ backgroundImage: "url(images/about-bg.png)" }}
        >
          <div
            className="aone-bg-cow"
            style={{ backgroundImage: "url(images/cow.png)" }}
          />
          <div className="site-top-line" />
          <div className="container">
            {/*Title Section Start*/}
            {/* <div className="section-head center">
              <span className="aon-sub-title">Our Great Teem</span>
              <h2 className="aon-title">Meet Our Farmer</h2>
            </div> */}
            {/*Title Section End*/}
            <div className="section-content">
              {/* <div className="aon-team-section">
                <div className="row">
                 
                  <div className="col-lg-4 col-md-6">
                    <div
                      className="aon-team-box text-center  wow fadeInDown"
                      data-wow-duration="1000ms"
                    >
                      <div className="aon-team-pic">
                        <img src="images/team/pic1.png" alt="" />
                        <div className="aon-team-social">
                          <i className="aon-social-circle feather-plus" />
                          <div className="social-icons">
                            <a className="social-icon social-icon--twitter">
                              <i className="fa fa-twitter" />
                              <div className="tooltip">Twitter</div>
                            </a>
                            <a className="social-icon social-icon--linkedin">
                              <i className="fa fa-linkedin" />
                              <div className="tooltip">LinkedIn</div>
                            </a>
                            <a className="social-icon social-icon--facebook">
                              <i className="fa fa-facebook" />
                              <div className="tooltip">Facebook</div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <h4 className="aon-team-name">Daniel Samuel</h4>
                      <span className="aon-team-positopn">
                        Field Farmer Maintanancer
                      </span>
                    </div>
                  </div>
                 
                  <div className="col-lg-4 col-md-6">
                    <div
                      className="aon-team-box text-center  wow fadeInDown"
                      data-wow-duration="2000ms"
                    >
                      <div className="aon-team-pic">
                        <img src="images/team/pic2.png" alt="" />
                        <div className="aon-team-social">
                          <i className="aon-social-circle feather-plus" />
                          <div className="social-icons">
                            <a className="social-icon social-icon--twitter">
                              <i className="fa fa-twitter" />
                              <div className="tooltip">Twitter</div>
                            </a>
                            <a className="social-icon social-icon--linkedin">
                              <i className="fa fa-linkedin" />
                              <div className="tooltip">LinkedIn</div>
                            </a>
                            <a className="social-icon social-icon--facebook">
                              <i className="fa fa-facebook" />
                              <div className="tooltip">Facebook</div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <h4 className="aon-team-name">Daniel Samuel</h4>
                      <span className="aon-team-positopn">
                        Field Farmer Maintanancer
                      </span>
                    </div>
                  </div>

                  <div
                    className="col-lg-4 col-md-6  wow fadeInDown"
                    data-wow-duration="3000ms"
                  >
                    <div className="aon-team-box text-center">
                      <div className="aon-team-pic">
                        <img src="images/team/pic3.png" alt="" />
                        <div className="aon-team-social">
                          <i className="aon-social-circle feather-plus" />
                          <div className="social-icons">
                            <a className="social-icon social-icon--twitter">
                              <i className="fa fa-twitter" />
                              <div className="tooltip">Twitter</div>
                            </a>
                            <a className="social-icon social-icon--linkedin">
                              <i className="fa fa-linkedin" />
                              <div className="tooltip">LinkedIn</div>
                            </a>
                            <a className="social-icon social-icon--facebook">
                              <i className="fa fa-facebook" />
                              <div className="tooltip">Facebook</div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <h4 className="aon-team-name">Daniel Samuel</h4>
                      <span className="aon-team-positopn">
                        Field Farmer Maintanancer
                      </span>
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="aon-product-section">
                <div className="row">
                  {/* Column 1 */}
                  <div
                    className="col-lg-6 wow fadeInDown"
                    data-wow-duration="1000ms"
                  >
                    <div className="aon-product-left">
                      <div className="aon-pro-pic1">
                        <img src="images/company.jpeg" alt="" />
                        <div className="aon-pro-pic-circle">
                          <div className="aon-pro-pic-num">
                            <strong>20+</strong>
                            <span>Awards</span>
                          </div>
                          <div className="aon-pro-pic-animate spin-one" />
                        </div>
                      </div>
                      <div className="aon-pro-pic2">
                        <img src="images/award.JPG" alt="" />
                        <span className="aon-pro-pic-label">
                          2006 Since Our Firm
                        </span>
                      </div>
                    </div>
                  </div>
                  {/* Column 2 */}
                  <div
                    className="col-lg-6 wow fadeInDown"
                    data-wow-duration="2000ms"
                  >
                    <div className="aon-product-right">
                      <span className="aon-sub-title">Who we are</span>
                      <h2 className="aon-pro-title">
                        For That You Will Take <br />
                        Our Products.
                      </h2>
                      <div className="aon-pro-tagline">
                        Your trusted source for high-quality Cattle Feed
                        Supplements since 2006. Offering nutritious products for
                        your cattle's well-being. Contact us now!
                      </div>
                      <p>
                        Customer satisfaction is at the core of our business
                        philosophy. We take pride in the fact that our products
                        have been widely appreciated by customers across the
                        market. We strive to provide the best-in-class Cattle
                        Feed Supplements that not only nourish the animals but
                        also contribute to their overall health and performance.
                      </p>
                      {/* <p>
                          Nullam mollis diam augue. Maecenas ornare purus diam,
                          nec pellentesque sem porttitor et.
                        </p> */}
                      <div className="row">
                        <div className="col-md-6 col-sm-6">
                          <div className="aon-pro-box">
                            <div className="aon-pro-icon">
                              {/* <i className="flaticon-fruit aon-icon" /> */}
                              <img src="images/animal-feed-icon.png" />
                            </div>
                            <h4 className="aon-pro-title2">
                              Organic <br />
                              Feed
                            </h4>
                          </div>
                        </div>
                        <div className="col-md-6 col-sm-6">
                          <div className="aon-pro-box">
                            <div className="aon-pro-icon">
                              {/* <i className="flaticon-milk-1 aon-icon" /> */}
                              <img src="images/milk.png" />
                            </div>
                            <h4 className="aon-pro-title2">
                              A2 <br />
                              Milk
                            </h4>
                          </div>
                        </div>
                      </div>
                      <button
                        className="site-button btn-animate-one"
                        onClick={aboutNavigation}
                      >
                        More About us
                        <i className="btn-arrow-icon fa fa-angle-right" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br></br>
            <br></br>
            <br></br>
            <span className="aon-sub-title center">Our New Unit</span>
            <ReactCompareSlider
              itemOne={
                <ReactCompareSliderImage
                  src="/images/slide/2.png"
                  alt="Image one"
                />
              }
              itemTwo={
                <ReactCompareSliderImage
                  src="/images/slide/1.png"
                  alt="Image two"
                />
              }
            />
            <div className="site-bot-line2" />
          </div>
        </section>
      
        {/* <YouTube
          videoId="gyW-7qZiPzQ"
          opts={{
            height: "800",
            width: "100%",

            playerVars: {
              controls: 0,
              modestbranding: 1,
            },
          }}
        /> */}

        {/* Latest News End */}
        {/* All Projects */}
        {/* <section className="aon-all-projects-area">
          <div className="site-top-line2" />
          <div className="container-fluid">
          
            <div className="section-head center">
             
              <h2 className="aon-title">Our Gallery</h2>
            </div>
         
            <div className="section-content">
              <div className="row">
            
                <div className="col-xl-3 col-lg-4 col-md-6">
                  <div
                    className="aon-project-box wow fadeInDown"
                    data-wow-duration="2000ms"
                  >
                    <div className="aon-project-pic">
                      <img src="images/projects/img1.jpg" alt="" />
                    </div>
                    <div className="aon-project-overlay" />
                    <h2 className="aon-project-name">
                      Visit Our planned modern farm
                    </h2>
                    <a href="javascript:;" className="aon-project-more">
                      <i className="fa fa-angle-right" />
                    </a>
                  </div>
                </div>
              
                <div className="col-xl-6 col-lg-4 col-md-6 ">
                  <div
                    className="aon-project-box aon-pro-large wow fadeInDown"
                    data-wow-duration="2000ms"
                  >
                    <div className="aon-project-pic">
                      <img src="images/projects/img2.jpg" alt="" />
                    </div>
                    <div className="aon-project-overlay" />
                    <h2 className="aon-project-name">
                      Visit Our planned modern farm
                    </h2>
                    <div className="aon-project-more">
                      <i className="fa fa-angle-right" />
                    </div>
                  </div>
                </div>
               
                <div
                  className="col-xl-3 col-lg-4 col-md-6 wow fadeInDown"
                  data-wow-duration="2000ms"
                >
                  <div className="aon-project-box">
                    <div className="aon-project-pic">
                      <img src="images/projects/img3.jpg" alt="" />
                    </div>
                    <div className="aon-project-overlay" />
                    <h2 className="aon-project-name">
                      Visit Our planned modern farm
                    </h2>
                    <a href="javascript:;" className="aon-project-more">
                      <i className="fa fa-angle-right" />
                    </a>
                  </div>
                </div>
               
                <div
                  className="col-xl-6 col-lg-4 col-md-6 aon-pro-large wow fadeInDown"
                  data-wow-duration="3000ms"
                >
                  <div className="aon-project-box">
                    <div className="aon-project-pic">
                      <img src="images/projects/img4.jpg" alt="" />
                    </div>
                    <div className="aon-project-overlay" />
                    <h2 className="aon-project-name">
                      Visit Our planned modern farm
                    </h2>
                    <a href="javascript:;" className="aon-project-more">
                      <i className="fa fa-angle-right" />
                    </a>
                  </div>
                </div>
             
                <div className="col-xl-3 col-lg-4 col-md-6">
                  <div
                    className="aon-project-box wow fadeInDown"
                    data-wow-duration="3000ms"
                  >
                    <div className="aon-project-pic">
                      <img src="images/projects/img5.jpg" alt="" />
                    </div>
                    <div className="aon-project-overlay" />
                    <h2 className="aon-project-name">
                      Visit Our planned modern farm
                    </h2>
                    <a href="javascript:;" className="aon-project-more">
                      <i className="fa fa-angle-right" />
                    </a>
                  </div>
                </div>
            
                <div className="col-xl-3 col-lg-4 col-md-6">
                  <div
                    className="aon-project-box wow fadeInDown"
                    data-wow-duration="3000ms"
                  >
                    <div className="aon-project-pic">
                      <img src="images/projects/img6.jpg" alt="" />
                    </div>
                    <div className="aon-project-overlay" />
                    <h2 className="aon-project-name">
                      Visit Our planned modern farm
                    </h2>
                    <a href="javascript:;" className="aon-project-more">
                      <i className="fa fa-angle-right" />
                    </a>
                  </div>
                </div>
                <div className="view-more-btn text-center">
                  <button className="site-button-secondry btn-animate-one">
                    View All More{" "}
                    <i className="btn-arrow-icon fa fa-angle-right" />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="aon-pro-top-pic">
            <img src="images/cow2.png" alt="" />
          </div>
          <div className="aon-pro-bot-pic">
            <img src="images/cow3.png" alt="" />
          </div>
        </section> */}
        {/* All Projects End */}
        {/* Testimonials */}
        <section className="aon-testmo-area">
          <div className="" />
          <div className="">
            {/*Title Section Start*/}
            <div className="section-head center mt-5">
              <span className="aon-sub-title ">What Clients Says?</span>
              <h2 className="aon-title">Clients Feedback</h2>
            </div>
            {/*Title Section End*/}
            <div className="section-content">
              <div className="row" style={{ display: "flex" }}>
                {/* COLUMNS 1 */}
                <div className="item col-md-3">
                  <div
                    className="aon-testmo-wrap wow fadeInDown"
                    data-wow-duration="2000ms"
                  >
                    <div className="">
                      <i className="flaticon-quotation" />
                    </div>
                    <div className="aon-testmo-text">
                      <YouTube
                        videoId="QrGKo0TRueY"
                        opts={{
                          height: "500",
                          width: "300",

                          playerVars: {
                            // https://developers.google.com/youtube/player_parameters
                            controls: 0,
                            modestbranding: 1,
                          },
                        }}
                      />
                    </div>
                    {/* <div className="aon-testmo-rating">
                      <span className="fa fa-star" />
                      <span className="fa fa-star" />
                      <span className="fa fa-star" />
                      <span className="fa fa-star" />
                      <span className="fa fa-star" />
                    </div> */}
                    {/* <div className="aon-testmo-name">Madison Hazel</div>
                    <div className="aon-testmo-position">
                      Owner Of Business &amp; President.
                    </div> */}
                  </div>
                </div>
                {/* COLUMNS 2 */}
                <div className="item col-md-3">
                  <div
                    className="aon-testmo-wrap  wow fadeInDown"
                    data-wow-duration="2000ms"
                  >
                    <div className="">
                      <i className="flaticon-quotation" />
                    </div>
                    <div className="aon-testmo-text">
                      <YouTube
                        videoId="xuWveSEsV9I"
                        opts={{
                          height: "500",
                          width: "300",

                          playerVars: {
                            // https://developers.google.com/youtube/player_parameters
                            controls: 0,
                            modestbranding: 1,
                          },
                        }}
                      />
                    </div>
                    {/* <div className="aon-testmo-rating">
                      <span className="fa fa-star" />
                      <span className="fa fa-star" />
                      <span className="fa fa-star" />
                      <span className="fa fa-star" />
                      <span className="fa fa-star" />
                    </div>
                    <div className="aon-testmo-name">Madison Hazel</div>
                    <div className="aon-testmo-position">
                      Owner Of Business &amp; President.
                    </div> */}
                  </div>
                </div>
                {/* COLUMNS 3 */}
                <div className="item col-md-3">
                  <div
                    className="aon-testmo-wrap  wow fadeInDown"
                    data-wow-duration="2000ms"
                  >
                    <div className="">
                      <i className="flaticon-quotation" />
                    </div>
                    <div className="aon-testmo-text">
                      <YouTube
                        videoId="1F2CddUSInc"
                        opts={{
                          height: "500",
                          width: "300",

                          playerVars: {
                            // https://developers.google.com/youtube/player_parameters
                            controls: 0,
                            modestbranding: 1,
                          },
                        }}
                      />
                    </div>
                    {/* <div className="aon-testmo-rating">
                      <span className="fa fa-star" />
                      <span className="fa fa-star" />
                      <span className="fa fa-star" />
                      <span className="fa fa-star" />
                      <span className="fa fa-star" />
                    </div>
                    <div className="aon-testmo-name">Madison Hazel</div>
                    <div className="aon-testmo-position">
                      Owner Of Business &amp; President.
                    </div> */}
                  </div>
                </div>
                {/* COLUMNS 4 */}
                <div className="item col-md-3">
                  <div
                    className="aon-testmo-wrap  wow fadeInDown"
                    data-wow-duration="2000ms"
                  >
                    <div className="">
                      <i className="flaticon-quotation" />
                    </div>
                    <div className="aon-testmo-text">
                      <YouTube
                        videoId="eMkVa_pmLOI"
                        opts={{
                          height: "500",
                          width: "300",

                          playerVars: {
                            // https://developers.google.com/youtube/player_parameters
                            controls: 0,
                            modestbranding: 1,
                          },
                        }}
                      />
                    </div>
                    {/* <div className="aon-testmo-rating">
                      <span className="fa fa-star" />
                      <span className="fa fa-star" />
                      <span className="fa fa-star" />
                      <span className="fa fa-star" />
                      <span className="fa fa-star" />
                    </div>
                    <div className="aon-testmo-name">Madison Hazel</div>
                    <div className="aon-testmo-position">
                      Owner Of Business &amp; President.
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials End */}
        {/* Testimonials */}
        {/* <section className="aon-add-area">
        <img src="images/hero-2.jpg" alt="" />
          <div className="container">
            <div
              className="section-content  wow fadeInDown"
              data-wow-duration="2000ms"
            >
              <img src="images/add-one.png" alt="" />
            </div>
          </div>
          <div className="site-bot-line" />
        </section> */}
        <img
          src="images/hero-2.jpg"
          alt=""
          style={{ marginBottom: isMobile ? "-584px" : "-400px" }}
        />
        <iframe
          src="https://3waytech.co/wp-content/mahalaxmi.html"
          title="Embedded Content"
          width="100%"
          height="500px"
          frameBorder="0"
        ></iframe>
        {/* Testimonials End */}
      </div>
    </>
  );
}

export default Home;
